import React from "react"
import ReactModal from "./ReactModal"
import { useTheme } from "styled-components"
import PageModal from "./PageModal"
import PageModalBody from "./PageModalBody"
import ModalFooter from "./styled/ModalFooter"
import ModalTitle from "./styled/ModalTitle"
import { TxlGhostButton, TxlButton } from "./TxlButton"

const ConfirmationDialog = ({ modalProps, accept, dismiss, ...rest }) => {
  const theme = useTheme()

  return (
    <ReactModal onRequestClose={dismiss} {...rest}>
      <PageModal size="md">
        {modalProps.title && <ModalTitle>{modalProps.title}</ModalTitle>}
        <PageModalBody>{modalProps.body}</PageModalBody>
        <ModalFooter>
          <TxlGhostButton onClick={dismiss}>{modalProps.cancel}</TxlGhostButton>
          {modalProps.ok && (
            <TxlButton
              $primaryColor={modalProps.danger ? theme.color.invalid : null}
              onClick={accept}
            >
              {modalProps.ok}
            </TxlButton>
          )}
        </ModalFooter>
      </PageModal>
    </ReactModal>
  )
}

export default ConfirmationDialog
